const baseButton = {
    textTransform: 'capitalize',
    padding: '6px 30px',
};
export const UpdateMachineDialogStyle = {
    formWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        marginTop: '11px',
    },

    cancelButton: { ...baseButton, color: '#1424f9', border: '1px solid #1424f9' },
    saveButton: { ...baseButton, background: '#1424f9' },
    dialogContent: { padding: '11px 22px 11px 22px' },
    dialogAction: { padding: '0px 22px 11px 22px' },
    selectField: {
        '>div': {
            padding: '3px 10px',
        },
        width: '100%',
        height: '100%',
    },
    textInput: {
        padding: '3px 10px',
        '& input::placeholder': {
            color: '#6D6F81',
            opacity: 1,
        },
        borderRadius: '0px 4px 4px 0px',
    },
};
